import { Box } from '@mui/material';
import ReportFiltersProvider, { ReportFiltersProviderProps } from './ReportFiltersProvider';

export type ReportFiltersProps<TGroupBy> = ReportFiltersProviderProps<TGroupBy>;

const ReportFilters = <TGroupBy,>({ children, ...others }: ReportFiltersProps<TGroupBy>) => (
  <ReportFiltersProvider {...others}>
    <Box data-guide="report-filters-panel">{children}</Box>
  </ReportFiltersProvider>
);

export default ReportFilters;
